import {useParams} from '@aboutyou/router';
import {getEntityIdFromRouteParam} from '@aboutyou/utils';
import {PRODUCTS_PER_PAGE} from '../../../features/ProductStream/constants';
import {useAppliedPotentialFilters} from '../../../features/ProductStream/utils';

export const useCategoryIdentifierFooter = () => {
  const {categoryId} = useParams<{
    categoryId?: string;
  }>();
  const id = getEntityIdFromRouteParam(categoryId);
  const appliedFilters = useAppliedPotentialFilters();
  const page = 1;

  return id
    ? {
        categoryIdentifier: {
          identifier: {
            $case: 'id' as const,
            id,
          },
        },
        appliedFilters: {
          filters: appliedFilters,
          quickFilter: {},
        },
        pagination: {
          offset: (page - 1) * PRODUCTS_PER_PAGE,
          limit: page * PRODUCTS_PER_PAGE,
        },
      }
    : null;
};
